// @ts-nocheck
import { businessDisplayName } from '../lib/format';

/**
 * @param {{
 *  businesses: { tenant_id?: string, business_name?: string, email?: string, hide_by_default?: boolean }[],
 *  value: string,
 *  onChange: (tenantId: string) => void,
 *  allowAll?: boolean,
 *  label?: string
 * }} props
 */
export default function BusinessPicker({ businesses, value, onChange, allowAll = true, label = 'Business' }) {
  const rows = (businesses || []).filter((row) => !row.hide_by_default);
  return (
    <label className="inline-flex items-center gap-2 text-sm">
      <span className="text-slate-600">{label}</span>
      <select
        aria-label={label}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="h-9 rounded-lg border border-[#7C8798] bg-white px-3 text-sm"
      >
        {allowAll ? <option value="">All businesses</option> : null}
        {rows.map((row) => (
          <option key={row.tenant_id} value={row.tenant_id}>{businessDisplayName(row)}</option>
        ))}
      </select>
    </label>
  );
}
